module.exports = __webpack_public_path__ + "static/media/header.cfef43d1.mp3";